export default __webpack_public_path__ + "static/media/rocket.e70fcc77.png";